import { Link } from "react-router-dom";
import { useBilingual } from "@/lib/bilingual";
import { asset } from "@/lib/asset";

const ContactClosingCTA = () => {
  const b = useBilingual();
  return (
    <section className="relative py-14 md:py-24 overflow-hidden bg-stone-950">
      <div className="absolute inset-0 opacity-8">
        <img
          src={asset("/editorial/contact-cta-bg.jpg")}
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-stone-950/90 to-stone-950/95" />
      <div className="absolute top-0 left-0 right-0 h-px bg-amber-700/30" />

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 text-center">
        <div className="flex items-center justify-center gap-4 mb-8">
          <span className="block h-px w-12 bg-amber-700/50" />
          <span className="text-amber-500 text-xs font-semibold tracking-widest uppercase">
            {b("We're Here to Help", "我們在此為您服務")}
          </span>
          <span className="block h-px w-12 bg-amber-700/50" />
        </div>

        <h2
          className="text-3xl md:text-5xl font-bold text-white mb-5 leading-tight max-w-2xl mx-auto"
          style={{ fontFamily: "var(--font-display)" }}
        >
          {b(
            "Let's start your next furniture programme together.",
            "一起開啟您下一個家具採購計畫。",
          )}
        </h2>
        <p className="text-stone-500 text-sm max-w-md mx-auto mb-10 leading-relaxed">
          {b(
            "Whether you need a single SKU or a containerised collection, our export team is one message away.",
            "無論您要單一 SKU 或整櫃系列，外銷團隊一封訊息即可聯繫。",
          )}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact?intent=quote"
            onClick={() => {
              // Already on /contact: a Link to the same URL won't change the
              // query, so the form's intent effect can't re-fire. Scroll to
              // the form directly (guaranteed same-page). Cross-page entries
              // are handled by ContactForm's on-navigation intent effect.
              document
                .getElementById("contact-form")
                ?.scrollIntoView({ behavior: "smooth", block: "start" });
            }}
            className="bg-amber-700 hover:bg-amber-600 text-white font-semibold px-10 py-4 rounded-full transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
          >
            {b("Start an Inquiry", "開始詢價")}
          </Link>
          <a
            href="mailto:pro@forwaro.com"
            className="border border-stone-600 hover:border-stone-400 text-stone-300 hover:text-white font-semibold px-10 py-4 rounded-full transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
          >
            {b("Email Us Directly", "直接寄信")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactClosingCTA;
